import { useCallback } from 'react'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import AppStore from '@v4/store/appStore'
import PageBuilderModel from '@v4/store/builderStore/models/PageBuilder.model'
import useStyles from './ThemeButton.styled'
import { useSectionId } from '../../SectionItem.context'

export const useThemeButton = ({ className }) => {
	const classes = useStyles()
	const sectionId = useSectionId()
	const { setActiveSectionId, setSidebarMode } = PageBuilderSelector.useActions()
	const { setThemeButtonVisible } = AppStore.useStoreActions(state => state.general)

	const handleClick = useCallback(() => {
		setActiveSectionId({ id: sectionId })
		setSidebarMode(PageBuilderModel.SIDEBAR_MODE.SECTIONS)
		setThemeButtonVisible(false)
	}, [sectionId, setActiveSectionId, setSidebarMode, setThemeButtonVisible])

	return [
		{
			className,
			classes,
		},
		{
			handleClick,
		},
	]
}
